import { z } from 'zod';

export const userPreferenceSchema = z.object({
  id: z.string(),
  channel: z.string(),
  messageCategory: z.string(),
  enabled: z.boolean(),
});
export type UserPreference = z.infer<typeof userPreferenceSchema>;

export const tenantPreferenceSchema = z.object({
  id: z.string(),
  channel: z.string(),
  messageCategory: z.string(),
  enabled: z.boolean(),
  maxWeeklyBudget: z.number().nullable(),
});
export type TenantPreference = z.infer<typeof tenantPreferenceSchema>;

export const userPreferenceInputSchema = z.object({
  channel: z.string(),
  messageCategory: z.string(),
  enabled: z.boolean(),
});
export type UserPreferenceInput = z.infer<typeof userPreferenceInputSchema>;

export const tenantPreferenceInputSchema = z.object({
  channel: z.string(),
  messageCategory: z.string(),
  enabled: z.boolean(),
  maxWeeklyBudget: z.number().nullable().optional(),
});
export type TenantPreferenceInput = z.infer<typeof tenantPreferenceInputSchema>;
